<template>
  <div>
    <el-card class="mb-10">
      <el-row>
        <el-col :span="12">
          <div id="qc2AreaChartContainer"></div>
        </el-col>
        <el-col :span="12">
          <div id="qc2RetentionChartContainer"></div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import Highcharts from "@/config/highcharts";
window.qc2AreaChart = null;
window.qc2RetentionChart = null;
export default {
  props: ["qc2Data"],
  data() {
    return {
      chartData: {
        chart: {
          zoomType: "x",
          renderTo: "chartTarget",
        },
        scrollbar: {
          enabled: true,
          height: 10,
          showFull: false,
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
          enabled: false,
        },
        title: {
          text: "Area: 6−MAM 1 −− 1",
        },

        decimals: true,
        credits: {
          enabled: false,
        },
        yAxis: [
          {
            title: {
              text: "Area Count",
            },
            allowDecimals: false,
            lineWidth: 2,
            gridLineWidth: 0,
            tickWidth: 2,

            showEmpty: true,

            tickInterval: 1000,
          },
        ],
        xAxis: {
          categories: [],
          tickWidth: 2,
          tickmarkPlacement: "on",
          labels: {
            rotation: 290,
          },
          events: {
            afterSetExtremes: () => {},
          },
        },
        series: [
          {
            name: "",
            data: [],
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "downloadPNG",
                "downloadPDF",

                "separator",
                "downloadCSV",
              ],
            },
          },
        },
      },
      chartData2: {
        chart: {
          zoomType: "x",
          renderTo: "chartTarget",
        },
        scrollbar: {
          enabled: true,
          height: 10,
          showFull: false,
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "top",
          enabled: false,
        },
        title: {
          text: "Retention: 6−MAM 1 −− 1",
        },

        decimals: true,
        credits: {
          enabled: false,
        },
        yAxis: [
          {
            title: {
              text: "Retention Time (minutes)",
            },
            allowDecimals: false,
            lineWidth: 2,
            gridLineWidth: 0,
            tickWidth: 2,

            showEmpty: true,

            tickInterval: 1,
          },
        ],
        xAxis: {
          categories: [],
          tickWidth: 2,
          tickmarkPlacement: "on",
          labels: {
            rotation: 290,
          },
          events: {
            afterSetExtremes: () => {},
          },
        },
        series: [
          {
            name: "",
            data: [],
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "downloadPNG",
                "downloadPDF",

                "separator",
                "downloadCSV",
              ],
            },
          },
        },
      },
    };
  },
  async mounted() {
    await this.prepareChartData();
  },
  methods: {
    prepareChartData() {
      if (this.qc2Data.area_data) {
        let categories1 = this.qc2Data.area_data.map((e) => e.name);
        let values1 = this.qc2Data.area_data.map((e) => e.value);
        this.chartData.xAxis.categories = categories1;
        this.chartData.series[0].data = values1;
        this.chartData.title.text = `Area: ${this.qc2Data.drug} −− QCM`;

        window.qc2AreaChart = Highcharts.chart(
          "qc2AreaChartContainer",
          this.chartData
        );
      }
      if (this.qc2Data.retention_data) {
        let categories2 = this.qc2Data.retention_data.map((e) => e.name);
        let values2 = this.qc2Data.retention_data.map((e) => e.value);
        this.chartData2.xAxis.categories = categories2;
        this.chartData2.series[0].data = values2;
        this.chartData2.title.text = `Retention: ${this.qc2Data.drug} −− QCM`;

        window.qc2RetentionChart = Highcharts.chart(
          "qc2RetentionChartContainer",
          this.chartData2
        );
      }
    },
  },
};
</script>

<style lang="scss"></style>
